import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {GenericLinkedResource} from '@catcore/types/base';
import {extractDataFromModel} from '@catcore/utils';
import {Parameter} from '@catmodules/models/parameters/types';
import {ProjectParameter} from '@catmodules/models/project-parameters/types';
import {Service} from '@catmodules/models/project-service-files/types';
import {ProjectUnit} from '@catmodules/models/project-units/types';
import {Restangular} from 'ngx-restangular';
import {isNullOrUndefined} from 'util';

/**
 * Service to manage all things around a ProjectUnit
 */
@Injectable()
export class ProjectUnitsService extends RestHttpService<ProjectUnit> {

  constructor(service: Restangular) {
    super('project-units', service);
  }

  /**
   * Returns a human readable name for a ProjectUnit.
   *
   * It goes through a a list of possible sources for a useable name and uses the last possible one;
   *
   * @param {} projectUnit
   * @returns {any}
   */
  getNameForUnit(projectUnit: ProjectUnit) {

    if (
        !isNullOrUndefined(projectUnit.display_label) &&
        projectUnit.display_label.length > 0
    ) {
        return projectUnit.display_label;
    }

    if (!isNullOrUndefined(projectUnit.label)) {
      return projectUnit.label;
    }

    if (!isNullOrUndefined(projectUnit.name)) {
      return projectUnit.name;
    }

    if (Object.keys(projectUnit).includes('part_number')) {
      let label = projectUnit.part_number;
      if (!isNullOrUndefined(projectUnit.location_address)) {
        label = projectUnit.part_number.substr(0, 7);
        label = label + '#' + ("0" + projectUnit.location_address).slice(-2);
      }
      return label;
    }

    let hasLinkedType = Object.keys(projectUnit).includes('_links');
    hasLinkedType = hasLinkedType && Object.keys(projectUnit._links).includes('type');
    if (hasLinkedType) {
      return projectUnit._links.type.label;
    }

    return `${projectUnit.id}`;
  }

  extractParametersFor(unit: ProjectUnit): Parameter[] {
    return extractDataFromModel<ProjectUnit>(unit, 'parameters', '_embedded');
  }

  extractServicesFor(unit: ProjectUnit): GenericLinkedResource[] {
    return extractDataFromModel<ProjectUnit>(unit, 'services');
  }

  extractNetworkInterfacesFor(unit: ProjectUnit): GenericLinkedResource[] {
    return extractDataFromModel<ProjectUnit>(unit, 'network_interfaces');
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-units/services/project-units.service.ts